import styled from 'styled-components';

export const StyledArticle = styled.article`
  width: 100%;
  min-height: calc(100vh - 6vh - 8vh);
  max-width: 760px;
  margin: 0 auto;
  padding: var(--space-6) var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-5);

  .article__image {
    width: 100%;
    max-height: 420px;
    border-radius: var(--radius-lg);
  }

  .article__title {
    font-size: var(--fs-3xl);
    font-weight: var(--fw-black);
    line-height: var(--lh-tight);
    letter-spacing: -0.01em;
  }

  .article__title ~ .article__title {
    font-size: var(--fs-2xl);
    margin-top: var(--space-4);
  }

  .article__desc {
    color: var(--c-text);
    font-size: var(--fs-lg);
    line-height: var(--lh-base);
  }

  @media (min-width: 786px) {
    padding: var(--space-8) var(--space-6) var(--space-10);

    .article__title {
      font-size: var(--fs-4xl);
    }

    .article__title ~ .article__title {
      font-size: var(--fs-2xl);
    }
  }
`;
